import { ERC20_ABI } from "../Config/erc20";
import toast, { Toaster } from 'react-hot-toast';
import { CURRENT_CHAIN_ID, GetChainIndex, useWeb3, usehttpProvider } from "./useWeb3"
import { BUYCONTRACTABI, CHAINS } from "../Config/env";
import BigNumber from 'bignumber.js';
import Web3 from "web3"
import { getWalletAddress } from "../lib/localStorage";
import { getAccount } from "./useAccount";



export const UseERC20 = async (VALUE) => {
  try {
    const web3 = await useWeb3();
    // const web3 = await usehttpProvider();
    const Tokencontract = new web3.eth.Contract(ERC20_ABI, VALUE);
    return Tokencontract;
  } catch (e) {

  }
}

export const sleep = (ms) => {
  new Promise(resolve => setTimeout(resolve, ms))
}

export const toFixedNumber = (x) => {
  if (Math.abs(x) < 1.0) {
    var e = parseInt(x.toString().split('e-')[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
    }
  } else {
    var e = parseInt(x.toString().split('+')[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += (new Array(e + 1)).join('0');
    }
  }
  return x;
}

export const searchedValue = async (tokenList, searchSymbol) => {
  // console.log("searchedValue",tokenList,searchSymbol)
  const filteredData = await tokenList.filter(value => ((value.lockedPeriod)).includes(searchSymbol));
  return filteredData;
}

export const UseBuyContract = async () => {
  try {
    const web3 = await useWeb3();
    const index = GetChainIndex();
    const BUYCONTRACTADDRESS = CHAINS[index].BUYCONTRACTADDRESS

    const contract = new web3.eth.Contract(BUYCONTRACTABI, BUYCONTRACTADDRESS);
    return contract;
  } catch (e) {
    console.log(e, "UseBuyContract")
  }
}

export const BuyPlan = async (data) => {
  console.log("BuyPlanBuyPlan", data)
  const web3 = await useWeb3();
  try {
    const contract = await UseBuyContract();
    const account = getWalletAddress();
    console.log("🚀 ~ BuyPlan ~ account:", account)
    const gasPrice = await web3.eth.getGasPrice();

    let Buybot = await
      contract.methods
        .subscribe(data?.subId, data?.referrer)
        .send({
          from: web3.utils.toChecksumAddress(account),
          gasLimit: parseInt(220000),
          gasPrice: gasPrice,
        })
    return Buybot

  } catch (error) {
    console.log(error.message, "useBuyContract__err");
  }
};



export const ApproveToken = async (amount) => {
  const web3 = await useWeb3()
  try {

    const index = GetChainIndex();
    const BUYTOKENADDRESS = CHAINS[index].BUYTOKENADDRESS
    const BUYCONTRACTADDRESS = CHAINS[index].BUYCONTRACTADDRESS

    let contract = await UseERC20(BUYTOKENADDRESS)
    const account = getWalletAddress();
    // let params = [web3.utils.toChecksumAddress(BUYCONTRACTADDRESS), amount]
    // const { gasLimit, gasPrice } = await EstGas(params, ERC20_ABI, BUYTOKENADDRESS, 'approve', account)

    const gasPrice = await web3.eth.getGasPrice();
    let Approve = await contract.methods.approve(web3.utils.toChecksumAddress(BUYCONTRACTADDRESS), amount).send({
      from: web3.utils.toChecksumAddress(account), gasLimit: parseInt(220000),
      gasPrice: gasPrice,
    })
    console.log(Approve, 'ApproveToken')
    if (Approve) {
      return true
    } else {
      return false
    }
  } catch (err) {
    console.log("ApproveToken__err", err, true)
    return false
  }
}


export const EstGas = async (params, abi, contractAddress, methodName, account) => {
  try {
    const web3 = await useWeb3();
    const gasPrice = await web3.eth.getGasPrice();

    const gasPrice2 = localStorage.getItem('gasPrice')
    console.log(gasPrice, gasPrice2, "EstGas", params, contractAddress, methodName, account)

    const Contract = new web3.eth.Contract(abi, contractAddress)
    const encoded = await Contract.methods[methodName].apply(null, params).encodeABI();
    let estimatedGasLimit = await web3.eth.estimateGas({
      from: web3.utils.toChecksumAddress(account),
      to: web3.utils.toChecksumAddress(contractAddress),
      data: encoded,
    }).then((res) => {

    }).catch((error) => {
      console.log(error, "error+++++++++++")
    })

    return {
      gasLimit: parseInt(Number(estimatedGasLimit) * 1.5, 10),
      gasPrice: JSON.parse(gasPrice2)?.gasPrice
    }
  } catch (e) {
    console.log('EstGas_err', e, true);
    return false
  }
}


export const userPlanDetail = async () => {
  try {

    let contract = await UseBuyContract()
    const account = getWalletAddress();
    let user = await contract.methods.users(account).call()
    return user

  }
  catch (err) {
    console.log(err, "ERR")
  }
}


export const getOwnerAccount = async () => {
  try {

    let contract = await UseBuyContract()
    let owner = await contract.methods.owner().call()
    return owner

  }
  catch (err) {
    console.log(err, "ERR")
  }
}